import * as moment from 'moment';

export enum LANGUAGE_ENUM {
    DE = 'DE',
    EN = 'EN'
}
export enum RecordStatusEnum {
    New = 1,
    InProcess = 2,
    ReviewCompleted = 3,
    ProofReadingComplete = 4,
    Published = 5,
    Published_DE = 6
}

export interface IRecordEditResponseData extends IQuestionnaireResponseData {
    EndUserRecordJsonData: IQuestionnaireResponse[];
}

export interface IQuestionnaireResponseData {
    Id: any;
    RefId: any;
    Created: any;
    Update: any;
    Status: any;
    UniqueId: any;
    JsonData: IQuestionnaireResponse[];
}

export interface IQuestionnaireResponse {
    sectionNumber: number;
    sectionText: string;
    subSectionNumber: number;
    subSectionText: string;
    subSectionType: string;
    questionNumber?: number;
    questionText?: string;
    inputType?: string;
    response?: object;
}

export interface IQuestionnaireAnswer {
    value: any;
    freeText: any;
    extraOptions: IExtraOptionAnswer[];
}

export const EmptyAnswer = () => {
    return {
        value: null,
        freeText: null,
        extraOptions: []
    } as IQuestionnaireAnswer;
}

export interface IExtraOptionAnswer {
    value: string;
    hasError?: boolean;
}

export enum EnumQuestionType {
    NONE = 'NONE',
    INPUT = 'INPUT',
    TEXTAREA = 'TEXTAREA',
    DROPDOWN = 'DROPDOWN',
    DATE = 'DATE',
    MONTH = 'MONTH',
    OPTION = 'OPTION',
    ICD10SEARCH = 'ICD10SEARCH',
    POSNEGSLIDER = 'POSNEGSLIDER'
}

export enum EnumSectionType {
    SYMPTOMES = 'SYMPTOMES',
    MEDIKAMENT = "MEDIKAMENT",
    CAMTHERAPIE = 'CAMTHERAPIE'
}

export enum ISymptomeName {
    SymptomAuswahl = "SymptomAuswahl",
    NebenwirkungenAuswahl = "NebenwirkungenAuswahl"
}

export enum EnumMedikamentName {
    MedikamentTherapie = "MedikamentTherapie",
    NichtTherapie = "NichtTherapie"
}

export enum EnumCAMTherapieName {
    CAMTherapie = "CAMTherapie",
    CAMTherapieEnd = "CAMTherapieEnd"
}

export enum EnumSectionStatus {
    ACTIVE = "ACTIVE",
    COMPLETED = "COMPLETED"
}

export enum EnumInputSize {
    SMALL = "small",
    MEDIUM = "medium"
}

export interface IQuestionnaireSection {
    number: number;
    stepper: string;
    title: string;
    description?: string;
    infoText?: string;
    status?: EnumSectionStatus | null;
    subSections: IQuestionnaireSubSection[];
}

export interface IQuestionnaireSubSection {
    number: number;
    title?: string;
    description?: string;
    status?: EnumSectionStatus | null;
    required?: boolean;
    hasError?: boolean;
    questions: IQuestionnaireQuestion[];
    sectionType?: EnumSectionType;
    symptomeObj?: ISectionSymptome;
    medikamentObj?: IMedikamentObj;
    therapieObj?: ICAMTherapieObj;
}

export interface ISectionSymptome {
    dependedByThis?: ISymptomeName;
    dependedToThis?: ISymptomeName;
    symptomes?: ISymptomeObj[];
}

export interface ISymptomeObjRes {
    symptomes?: ISymptomeObj[];
}

export interface ISymptomeObj {
    label: string;
    before: {
        text: string;
        value: number;
    },
    after: {
        text: string;
        value: number;
    },
    showFreeText: boolean;
    freeText: string;
}

export const GenereateSymptome = (symptomeName: ISymptomeName, label: string, language: LANGUAGE_ENUM) => {
    return {
        label: label,
        before: {
            text: getSymptomeText(symptomeName, true, language),
            value: 0
        },
        after: {
            text: getSymptomeText(symptomeName, false, language),
            value: 0
        },
        showFreeText: false,
        freeText: ""
    } as ISymptomeObj;
}

export interface ITherapieItemObjAnswer {
    value: any;
    freeText: any;
}
export const TherapieItemEmptyAnswer = () => {
    return {
        value: null,
        freeText: null
    } as ITherapieItemObjAnswer;
}

export interface ITherapieItemObj {
    title?: string;
    label?: string;
    inputType: EnumQuestionType;
    placeholder?: string;
    options?: any[];
    required?: boolean;
    monthObj?: IMonth;
    freeTextInput?: IFreeTextInput;
    hidden?: boolean;
}

export interface IMedikamentError {
    medikament: boolean,
    darreichungsform: boolean,
    vorTherapie: boolean,
    unterTherapie: boolean,
}

export interface IMedikamentRes {
    medikament: ITherapieItemObjAnswer;
    vorTherapie: ITherapieItemObjAnswer;
    unterTherapie: ITherapieItemObjAnswer;
    showFreeText: boolean;
    freeText: string;
    hasError: IMedikamentError;
}

export interface IMedikamentResObj extends IMedikamentRes {
    darreichungsform: ITherapieItemObjAnswer;
}

export interface INichtMedikamentResObj extends IMedikamentRes {
}

export const GenereateMedikamentRes = () => {
    return {
        medikament: TherapieItemEmptyAnswer(),
        darreichungsform: TherapieItemEmptyAnswer(),
        vorTherapie: TherapieItemEmptyAnswer(),
        unterTherapie: TherapieItemEmptyAnswer(),
        showFreeText: false,
        freeText: "",
        hasError: {
            medikament: false,
            darreichungsform: false,
            vorTherapie: false,
            unterTherapie: false
        }
    } as IMedikamentResObj;
}

export const GenereateNichtRes = () => {
    return {
        medikament: TherapieItemEmptyAnswer(),
        vorTherapie: TherapieItemEmptyAnswer(),
        unterTherapie: TherapieItemEmptyAnswer(),
        showFreeText: false,
        freeText: "",
        hasError: {
            medikament: false,
            vorTherapie: false,
            unterTherapie: false
        }
    } as INichtMedikamentResObj;
}

export interface IMedikamentResponseObj {
    medikamentName: EnumMedikamentName,
    responseData?: IMedikamentResObj[] | INichtMedikamentResObj[];
}

export interface IMedikamentObj extends IMedikamentResponseObj {
    addMore?: string;
    required: boolean;
    medikament: ITherapieItemObj;
    darreichungsform?: ITherapieItemObj;
    vorTherapie: ITherapieItemObj;
    unterTherapie: ITherapieItemObj;
}


export interface ICAMTherapieError {
    category: boolean,
    product: boolean,
    startDate: boolean,
    phaseDuration: boolean,
    applicationUnit: boolean,
    dailyDosage: boolean,
    remarks: boolean
}
export interface ICAMTherapieResObj {
    category: ITherapieItemObjAnswer;
    product: ITherapieItemObjAnswer;
    startDate: ITherapieItemObjAnswer;
    phaseDuration: ITherapieItemObjAnswer;
    applicationUnit: ITherapieItemObjAnswer;
    dailyDosage: ITherapieItemObjAnswer;
    remarks: ITherapieItemObjAnswer;
    hasError: ICAMTherapieError;
}

export interface ICAMTherapieEndError {
    category: boolean,
    product: boolean,
    startDate: boolean,
    endDate: boolean,
    applicationUnit: boolean,
    dailyDosage: boolean,
    remarks: boolean;
}

export interface ICAMTherapieEndResObj {
    category: ITherapieItemObjAnswer;
    product: ITherapieItemObjAnswer;
    startDate: ITherapieItemObjAnswer;
    endDate: ITherapieItemObjAnswer;
    applicationUnit: ITherapieItemObjAnswer;
    dailyDosage: ITherapieItemObjAnswer;
    remarks: ITherapieItemObjAnswer;
    hasError: ICAMTherapieEndError;
}

export const GenereateCAMRes = () => {
    return {
        category: TherapieItemEmptyAnswer(),
        product: TherapieItemEmptyAnswer(),
        startDate: TherapieItemEmptyAnswer(),
        phaseDuration: TherapieItemEmptyAnswer(),
        applicationUnit: TherapieItemEmptyAnswer(),
        dailyDosage: TherapieItemEmptyAnswer(),
        remarks: TherapieItemEmptyAnswer(),
        hasError: {
            category: false,
            product: false,
            startDate: false,
            phaseDuration: false,
            applicationUnit: false,
            dailyDosage: false,
            remarks: false
        }
    } as ICAMTherapieResObj;
}

export const GenereateCAMEndRes = () => {
    return {
        category: TherapieItemEmptyAnswer(),
        product: TherapieItemEmptyAnswer(),
        startDate: TherapieItemEmptyAnswer(),
        endDate: TherapieItemEmptyAnswer(),
        applicationUnit: TherapieItemEmptyAnswer(),
        dailyDosage: TherapieItemEmptyAnswer(),
        remarks: TherapieItemEmptyAnswer(),
        hasError: {
            category: false,
            product: false,
            startDate: false,
            endDate: false,
            applicationUnit: false,
            dailyDosage: false,
            remarks: false
        }
    } as ICAMTherapieEndResObj;
}


export interface ICAMTherapieResponseObj {
    therapieName: EnumCAMTherapieName,
    responseData?: ICAMTherapieResObj[] | ICAMTherapieEndResObj[];
}

export interface ICAMTherapieObj extends ICAMTherapieResponseObj {
    addMore?: string;
    required: boolean;
    category: ITherapieItemObj;
    product: ITherapieItemObj;
    startDate: ITherapieItemObj;
    endDate?: ITherapieItemObj;
    phaseDuration?: ITherapieItemObj;
    applicationUnit: ITherapieItemObj;
    dailyDosage: ITherapieItemObj;
    remarks: ITherapieItemObj;
}

export interface IQuestionClass {
    question?: string;
    title?: string;
    description?: string;
    lastInfo?: string;
}

export interface IQuestionnaireQuestion {
    answer: IQuestionnaireAnswer;
    number: number;
    title: string;
    description?: string;
    lastInfo?: string;
    extraClass?: IQuestionClass;
    placeholder?: string;
    inputType: EnumQuestionType;
    inputSize?: EnumInputSize;
    questSize?: EnumInputSize;
    freeTextInput?: IFreeTextInput;
    data?: any[];
    required?: boolean;
    removeOptionalClass?: boolean;
    hidden?: boolean;
    pattern?: RegExp;
    hasError?: boolean;
    divider?: boolean;
    multiple?: boolean;
    icdCode?: IICDCode;
    conditionalOptions?: IConditionalOptionsObj;
    extraOption?: IExtraOptionObj;
    monthObj?: IMonth;
    validateValueWith?: IValidateValueWith;
}

export interface IValidateValueWith {
    sectionNumber: number;
    subSectionNumber: number;
    questionNumber: number;
}

export interface IMonth {
    minMonth?: Date;
    maxMonth?: Date;
}

export enum EnumFreeTextType {
    INPUT = "INPUT",
    TEXTAREA = "TEXTAREA"
}

export interface IFreeTextInput {
    inputType: EnumFreeTextType;
    inputSize?: EnumInputSize;
    placeholder?: string;
}
export interface IExtraOptionObj {
    buttonText: string;
    multiple?: boolean;
}

export interface IICDCode {
    popupTitle: string;
    buttonText: string;
}

export interface IConditionalOptionsObj {
    dependedKey: string;
    options?: IConditionalOptions[];
}

export interface IConditionalOptions {
    label: string;
    options: string[];
}

export const getMinMonth = (year: number = 1980, month: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 = 0) => {
    return new Date(moment().year(year).month(month).startOf("month").toString());
}

export const getMaxMonth = (months: number = 0, add: boolean = true) => {
    let month: any;
    if (add) {
        month = moment().startOf('month').add(months, 'months').endOf("month").toString();
    } else {
        month = moment().startOf('month').subtract(months, 'months').endOf("month").toString();
    }
    return new Date(month);
}


export const getCategoryLabel = (label, language: LANGUAGE_ENUM) => {
    if (language == LANGUAGE_ENUM.EN) {
        switch (label) {
            case 'Cannabis flowers':
                return "Flowers";
            case 'Cannabis extract':
                return "Extracts";
            default:
                return label;
        }
    } else {
        switch (label) {
            case 'Cannabisblüten':
                return "Blüten";
            case 'Cannabisextrakt':
                return "Extrakte";
            case 'Cannabiskapseln':
                return "Kapseln";
            default:
                return label;
        }
    }
}

export const getFormCategoryLabels = (label, language: LANGUAGE_ENUM) => {
    if (language == LANGUAGE_ENUM.EN) {
        switch (label) {
            case 'inhalativ':
                return ["Flowers"];
            case 'oral':
                return ["Extracts", "Dronabinol", "Sativex"];
            case 'per os':
                return ["Cesamet", "Capsules"];
            default:
                return ["Flowers", "Extracts", "Dronabinol", "Sativex", "Cesamet", "Capsules", "Other"];
        }
    } else {
        switch (label) {
            case 'inhalativ':
                return ["Blüten"];
            case 'oral':
                return ["Extrakte", "Dronabinol", "Sativex"];
            case 'per os':
                return ["Canemes", "Kapseln"];
            default:
                return ["Blüten", "Extrakte", "Dronabinol", "Sativex", "Canemes", "Kapseln", "Andere"];
        }
    }
}

export const getSymptomeText = (symptomeName: ISymptomeName, before: boolean, language: LANGUAGE_ENUM) => {
    switch (symptomeName) {
        case ISymptomeName.SymptomAuswahl:
            if (before) {
                return language == LANGUAGE_ENUM.EN ? "Before MC" : "Vor CAM";
            } else {
                return language == LANGUAGE_ENUM.EN ? "Under MC" : "Unter CAM";
            }
        case ISymptomeName.NebenwirkungenAuswahl:
            if (before) {
                return language == LANGUAGE_ENUM.EN ? "Start of therapy" : "Therapie- beginn";
            } else {
                return language == LANGUAGE_ENUM.EN ? "Time of observation" : "Betrachtungs- zeitpunkt";
            }
    }
}

export const getFreeTextInput = (language: LANGUAGE_ENUM) => {
    return language == LANGUAGE_ENUM.EN ? "Other, free text" : "Andere, Freitext";
};

export const emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
export const freeTextInputs = ["Andere, Freitext", "Freitext", "Andere Begründung (Freitext)", "Other, free text", "Free text", "Other reason (free text)"];
